import { Fragment, } from "react"
import { Col, Row } from "antd"

interface Client {
    customer_name: string // 姓名
    customer_phone: string // 手机号码
    deal_date: string // 签单日期
    deal_store_name: string // 签单门店
    deal_item_name: string // 签单套餐名称
    service_days: number // 服务天数
}

interface Prop {
    data?: Client
}

export default function (props: Prop) {

    return <div className="follow-record">
        {/* 月嫂中心 -> 到府客户管理 -> 客户详情 -> 签单记录 */}
        <Fragment>
            <div className="common-main" style={{ marginTop: '5px' }}>
                <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>客户名称：{props.data?.customer_name}</Col>
                    <Col span={6}>客户手机号：{props.data?.customer_phone}</Col>
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>签单日期：{props.data?.deal_date}</Col>
                    <Col span={6}>签单门店：{props.data?.deal_store_name}</Col>
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>签单套餐：{props.data?.deal_item_name}</Col>
                    <Col span={6}>签单天数：{props.data?.service_days}</Col>
                </Row>
            </div>
        </Fragment>
    </div>
}